import { Component, AfterViewInit, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';

import { DocTemplate } from '../../../models/doc-template';

import { DocTemplateService } from '../../../services/documents/doc-template.service';
import { NotyService } from '../../../services/common/noty.service';
import { UserService } from '../../../services/users/user.service';

@Component({
  selector: 'app-doc-template-index',
  templateUrl: './doc-template-index.component.html',
  styleUrls: ['./doc-template-index.component.scss'],
})
export class DocTemplateIndexComponent implements AfterViewInit, OnInit {
  /**
   * Total number of doc templates found in current search
   * @type {number}
   */
  count: number = 0;

  /**
   * List of doc templates in current page
   * @type {Array<DocTemplate>}
   */
  docTemplates: Array<DocTemplate> = [];

  /**
   * Indicates if search is being performed
   * @type {boolean}
   */
  searching: boolean = false;

  searchOptions: any = {
    per_page: 20,
  };

  searchParams: any = {
    page: 1,
    per_page: 20,
    v4_templates: true,
  };

  /**
   * Indicates if sidebar is maximized on large screens
   * @type {boolean}
   */
  sidebarMaximized: boolean = false;

  /**
   * Inidicates if sidebar is open on small screens
   * @type {boolean}
   */
  sidebarOpen: boolean = false;

  /**
   * Constructor
   * @param {DocTemplateService} private docTemplateService Service to access doc templates controller
   * @param {NotyService}        private notyService        Service for UI notifications
   * @param {Router}             private router             Angular service for route change subscriptions and changing URL
   */
  constructor(private docTemplateService: DocTemplateService, private notyService: NotyService, private router: Router, private userService: UserService) {}

  // Component lifecycle functions

  /**
   * Called on component initialization
   */
  ngOnInit() {
    this.docTemplateService
      .searchOptions()
      .then((response_json) => {
        if (response_json && response_json.search_options) this.searchOptions = response_json.search_options;
        this.clearSearch();
        this.search();
        this.userService.navbarComponent.setDocumentTemplatesMenu();
      })
      .catch(() => {
        this.userService.navbarComponent.setDocumentTemplatesMenu();
      });
  }

  /**
   * Called after HTML is initialized
   */
  ngAfterViewInit() {
    setTimeout(() => {
      this.content_sidebar_scroll();
      this.search_height_maintainer();
    }, 500);
    setTimeout(() => {
      this.content_sidebar_scroll();
      this.search_height_maintainer();
    }, 5000);
  }

  // Component functions

  /**
   * Clear search
   */
  clearSearch() {
    this.searchParams = {
      page: 1,
      per_page: this.searchOptions.per_page || 20,
      v4_templates: true,
    };
  }

  /**
   * Page changed
   * @param {any} $event Page change event with new page number
   */
  pageChanged($event: any) {
    this.searchParams.page = $event.page;
    this.search();
  }

  /**
   * Process search request
   */
  search() {
    this.searching = true;
    this.docTemplateService
      .index(this.searchParams)
      .then((response_json) => {
        this.searching = false;
        if (response_json && response_json.doc_templates) {
          this.docTemplates = response_json.doc_templates;
          this.count = response_json.doc_templates_size;
          if (this.count == 1 && this.docTemplates.length == 1) {
            this.router.navigateByUrl(`/doc_templates/${this.docTemplates[0].id}/edit`);
            return;
          }
          this.sidebarOpen = false;
        } else {
          this.docTemplates = [];
          this.count = 0;
          this.notyService.notify(response_json.text || 'Error getting document template search results', 'error', 5000, 'topRight');
        }
      })
      .catch(() => {
        this.searching = false;
        this.notyService.notify('Error getting document template search results', 'error', 5000, 'topRight');
      });
  }

  // Positioning events and methods
  @HostListener('window:scroll', ['$event'])
  window_scroll(event: Event) {
    this.content_sidebar_scroll();
    this.search_height_maintainer();
  }

  @HostListener('window:resize', ['$event'])
  window_resize(event: Event) {
    this.content_sidebar_scroll();
    this.search_height_maintainer();
  }

  content_sidebar_scroll() {
    var content_main = document.getElementById('content-main');
    var content_sidebar = document.getElementById('content-sidebar');
    var sidebar_height = window.innerHeight;
    if (content_sidebar && content_main) {
      if (content_main.getBoundingClientRect().top > 19) {
        content_sidebar.style.position = 'absolute';
        content_sidebar.style.top = content_main.offsetTop + 'px';
        sidebar_height -= content_main.getBoundingClientRect().top + 20;
        //console.log('greater ' + matter_sidebar.style.top);
      } else {
        content_sidebar.style.position = 'fixed';
        content_sidebar.style.top = '20px';
        sidebar_height -= content_sidebar.getBoundingClientRect().top + 20;
        //console.log('lesser ' + matter_sidebar.style.top);
      }

      if (content_sidebar.clientHeight != sidebar_height) content_sidebar.style.height = sidebar_height + 'px';
    }
  }

  search_height_maintainer() {
    var content_sidebar = document.getElementById('content-sidebar');
    var content_search = document.getElementById('search-form');
    if (content_sidebar && content_search) {
      var search_height = content_sidebar.clientHeight - 95;
    }
  }
}
